import React from "react";
import { EditableCell } from 'alumni-components/EditableCell/EditableCell';


export const  NotebookCell = ( {col, row, token, courseSubjectID, persona, updateItem } ) => { 
  const toolID = col.field;
  const tool = col.tool ;
  // col.tool && console.log(col.tool)

  // Update para los de tipo numerico
  const updateTypeNUM =  ( value ) => {
    updateItem ( token, courseSubjectID, persona.persona_id,  tool.tool_id,  null, value , null ) ;
  }

  // Update para los de tipo texto libre, sin nota
  const updateTypeTXT =  ( value ) => {
    updateItem ( token, courseSubjectID, persona.persona_id,  tool.tool_id,  null, null , value ) ;
  }

    // Update para los de tipo texto libre, sin nota
    const updateTypeOPT =  ( value ) => {
       updateItem ( token, courseSubjectID, persona.persona_id,  tool.tool_id,  value, null , null ) ;
    }

  // updateItem: ( token, courseSubjectID, personaID,  toolID,  evalTypeOptID, evalTypeValue , comments )

  
  let cell = row.find( f => f.tool_id === toolID);
  let dev = <></> ;

  // Si es la celda del nombre del alumno
  if (cell && cell.studentName) {  dev =  <EditableCell readOnly textAlign="left" defaultValue={cell.studentName} /> }

  else if (tool &&  tool.type === 'OPT' ) {
    let opt = {};
    if (cell && cell.eval_type_opt_id ) {
      opt = tool.eval_type_options.filter( o => o.eval_type_opt_id === cell.eval_type_opt_id)[0] ;
    }
    // Combo de opciones
    dev =    <EditableCell 
                contentType="number" 
                defaultValue={ opt } 
                updateValue={updateTypeOPT} 
                options={tool.eval_type_options.map( opt => { return { value: opt.eval_type_opt_id, label: opt.opt_value}})}
                type={tool.type}
              /> 

  } else if (tool &&  tool.type === 'NUM' ) { 
    // TODO: Minimos y maximos
    dev =  <EditableCell 
                contentType="number" 
                defaultValue={cell && cell.eval_type_value} 
                updateValue={updateTypeNUM} 
                type={tool.type}
                /> 
  } else { 
    dev =  <EditableCell
              readOnly = {tool.status ==='C'?true:false}
              maxLength={15} 
              defaultValue={cell && cell.comments} 
              updateValue={updateTypeTXT}
              type={tool.type}
              />

  }
  // si tiene eval_type_value es nota
  // else if (cell &&  cell.eval_type_value && cell.eval_type_value > 0 ) 
  
  // si no tiene ninguna va el comentario
  // else if (cell &&  cell.comments ) dev =  <EditableCell maxLength={15} defaultValue={cell.comments} />
  
  // else dev =  <EditableCell />
  

  return dev ;
}